import {StaticDecode, StaticEncode, TSchema} from "typebox";
import {Value} from "typebox/value";
// eslint-disable-next-line no-restricted-imports
import {Params, useParams} from "react-router-dom";
import {HTTPError} from "platformed-client";

type TStringRecord<T extends TSchema> = StaticEncode<T> extends Readonly<Params> ? T : never;

/** For use in loaders. */
export function typedParams<const T extends TSchema>(
  schema: TStringRecord<T>,
  value: Readonly<Params<string>>,
): StaticDecode<T> {
  try {
    return Value.Decode(schema, value);
  } catch (ex) {
    console.error("Error decoding params:", ex);
    throw new HTTPError(new Response(null, {status: 404}));
  }
}

/** For use in components. */
export function useTypedParams<const T extends TSchema>(schema: TStringRecord<T>): StaticDecode<T> {
  const value = useParams();
  return typedParams(schema, value);
}

/**
 * Reads the router splat (`*`) param. Splats cannot go through `useTypedParams`:
 * a schema property named "*" breaks typebox schema compilation (typebox builds
 * unescaped `^<key>$` regexes from property keys).
 */
export function useSplatParam(): string | undefined {
  return useParams()["*"];
}
